define(["data/config"], function(config) {
    var apply = function($element) {
        var products = [];
        var $vat = $element.find(
            "." + config.prefixes.component + "summary-vat"
        );
        var $total = $element.find(
            "." + config.prefixes.component + "summary-total"
        );

        var $discountAlert = $element.find(
            "." + config.prefixes.component + "summary-discount"
        );

        var $totalDiscounted = $element.find(
            "." + config.prefixes.component + "summary-total-discounted"
        );

        var currencySymbol = $element
            .find("." + config.prefixes.component + "summary-currency")
            .data("summary-currency-symbol");

        var taxName = $vat.data("summary-tax-name");
        $element
            .find("." + config.prefixes.component + "summary-product")
            .each(function(i, product) {
                products.push(product);
            });
        if ($vat && $vat.length > 0) {
            $vat.data(
                "summary-vat-price",
                parseFloat($vat.data("summary-vat-price"))
            );
            $vat
                .find("." + config.prefixes.component + "summary-item")
                .html("+" + $vat.data("summary-vat-price") + "% " + taxName);
        }

        var update = function() {
            var total = 0;
            var discountedTotal = 0;
            var vat = 0;
            var discountedVat = 0;
            var quantity = 1;
            var discount = 0;
            var discount_code = $("input[name=discount_code]").val();
            var product_id = $("input[name=product_id]").val();
            var flexible = false;
            products.map(function(product) {
                quantity = $(product)
                    .find("#quantity")
                    .val();
                
                var regular_price = $(product).data("summary-product-price");

                if(!$(product).data("summary-product-flexible-amount")){
                    product.price = parseFloat(
                        regular_price * quantity / 100
                    );
                }else{
                    if($('#user_amount').val() * 100 > regular_price){
                        product.price = parseFloat($('#user_amount').val() * quantity);
                        flexible = true;
                    }else{
                        product.price = parseFloat(regular_price * quantity / 100);
                        $('#user_amount').val(regular_price / 100)
                    }
                    $("." + config.prefixes.component + "summary-quantity").html(quantity);
                }
                total += product.price;

                discount = parseFloat($(product).data("summary-product-discount") / 100);
                if ($(product).data("summary-product-discount-type") == 'discount_percentage') {
                    discount = discount * quantity;
                }
                product.discountedPrice = product.price - discount;

                discountedTotal += product.discountedPrice;

                $(product)
                    .find("." + config.prefixes.component + "summary-price")
                    .html(currencySymbol + " " + product.price.toFixed(2));
            });

            if ($vat && $vat.length > 0) {
                if (!isNaN(discountedTotal)) {
                    vat =
                        discountedTotal / 100 * $vat.data("summary-vat-price");
                } else {
                    vat = total / 100 * $vat.data("summary-vat-price");
                }
                // Fixed rounding issues
                vat = Math.floor(vat * 100) / 100;

                discountedVat =
                    discountedTotal / 100 * $vat.data("summary-vat-price");
                discountedVat = Math.floor(discountedVat * 100) / 100;
                $vat
                    .find("." + config.prefixes.component + "summary-price")
                    .html(currencySymbol + " " + vat.toFixed(2));
            }

            if ($totalDiscounted.length > 0) {
                $totalDiscounted
                    .find(
                        "." + config.prefixes.component + "summary-price strong"
                    )
                    .html(
                        currencySymbol +
                            " " +
                            (discountedVat + discountedTotal).toFixed(2)
                    );
            }
            $total
                .find("." + config.prefixes.component + "summary-price strong")
                .html(currencySymbol + " " + (vat + total).toFixed(2));

            $discountAlert
                .find('.u_right strong')
                .html(currencySymbol + " " + discount.toFixed(2));

            $.ajaxSetup({headers: {"X-CSRF-Token": $('meta[name="_token"]').attr("content") }});
            // TODO: Add the rest of possible fields from the new form here and support for multi products!
            if(!flexible){
                var data = {'product_id': product_id, 'quantity': quantity, 'discount_code': discount_code};
            }else{
                var user_amount = $('#user_amount').val() * 100;
                var data = {'product_id': product_id, 'quantity': quantity, 'discount_code': discount_code, 'user_amount': user_amount};
            }
            $.post(config.eventUrl + 'cart/update', data);
        };

        update();
        $element.find("[name=quantity]").on("change", update);
        $element.find("[name=user_amount]").on("change", update);
    };

    return {
        name: "summary--auto",
        apply: apply
    };
});
